import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68b2355f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logistdetail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "t",
  style: {"margin-top":"0"}
}, "基础信息", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "t" }, "SKU信息", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "t" }, "收件人信息", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "t" }, "发件人信息", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "t" }, "揽收地址信息", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "t" }, "物流轨迹", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_table, {
      rowKey: "id",
      columns: _ctx.columns1,
      dataSource: _ctx.tableData.baseList,
      pagination: false,
      size: "small"
    }, {
      bodyCell: _withCtx(({column,record}) => [
        (column.dataIndex === 'orderSource')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(record.orderSource === 1 ? 'ERP' : '平台'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'hasBattery')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(record.orderSource === 1 ? '带电' : '普货'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'amount')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(_ctx.twoNumber(Number(record.amount))), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'productType')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.changeTxt(_ctx.text, 'productType')), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'width')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(record.length +'*'+ record.width + '*' + record.height), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'actualWidth')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createTextVNode(_toDisplayString(record.actualLength +'*'+ record.actualWidth + '*' + record.actualHeight), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "dataSource"]),
    _hoisted_3,
    _createVNode(_component_a_table, {
      rowKey: "id",
      columns: _ctx.columns2,
      dataSource: _ctx.tableData.orderSkuList,
      pagination: false,
      size: "small"
    }, {
      bodyCell: _withCtx(({column,record,text,index}) => [
        (column.dataIndex === 'index')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(index+1), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'hasBattery')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'hasBattery')), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'declareValue')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createTextVNode(_toDisplayString(_ctx.twoNumber(Number(record.declareValue))), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "dataSource"]),
    _hoisted_4,
    _createVNode(_component_a_table, {
      rowKey: "id",
      columns: _ctx.columns3,
      dataSource: _ctx.tableData.addresseeAddess,
      pagination: false,
      size: "small"
    }, {
      bodyCell: _withCtx(({column,record}) => [
        (column.dataIndex === 'countryCn')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.changeTxt(record.countryCode2, 'countryCn')), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'countryEn')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.changeTxt(record.countryCode2, 'countryEn')), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "dataSource"]),
    _hoisted_5,
    _createVNode(_component_a_table, {
      rowKey: "id",
      columns: _ctx.columns4,
      dataSource: _ctx.tableData.senderAddess,
      pagination: false,
      size: "small"
    }, {
      bodyCell: _withCtx(({column,record}) => [
        (column.dataIndex === 'countryCn')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.changeTxt(record.countryCode2, 'countryCn')), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'countryEn')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.changeTxt(record.countryCode2, 'countryEn')), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "dataSource"]),
    _hoisted_6,
    _createVNode(_component_a_table, {
      rowKey: "id",
      columns: _ctx.columns5,
      dataSource: _ctx.tableData.userAddress,
      pagination: false,
      size: "small"
    }, {
      bodyCell: _withCtx(({column, text, }) => [
        (column.dataIndex === 'auditStatus')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.txtchange(text,'auditStatus')), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.dataIndex === 'pickupCycle')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.txtchange(text, 'pick')) + " ", 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "dataSource"]),
    _hoisted_7,
    _createVNode(_component_a_table, {
      rowKey: "id",
      columns: _ctx.columns6,
      dataSource: _ctx.tableData.orderEventList,
      pagination: false,
      size: "small"
    }, null, 8, ["columns", "dataSource"])
  ]))
}